<template>
	<div class="w_1200">
		<div class="flex_js">
			<img src="../assets/img/logo.png" class="responsive-img" alt="" @click="goIndex" />
			<div class="flex">
				<div style="margin-right: 10px;">
					<div @click="languageAuto('zh-cn')" v-if="language == 'en-us'" style="text-align:center">
						<img src="../assets/img/icon1.png" style="width: 24px; height: 24px" alt="" />
						<div class="f14">中文</div>
					</div>
					<div @click="languageAuto('en-us')" v-else style="text-align:center">
						<img src="../assets/img/icon2.png" style="width: 24px; height: 24px" alt="" />
						<div class="f14">English</div>
					</div>
				</div>
				<div v-if="is_login" style="color: #000; text-decoration: none">
					<div class="flex right" style="">
						<img :src="avatar" style="width: 50px; height: 50px; border-radius: 50%; display: none;" alt="" />
						<div style="margin-left: 10px">
							<div class="f14" style="color: #4679f0" @click="goMy">{{nickname}}</div>
							<div class="f16" style="cursor: pointer" @click="quit">{{$t('login.logout')}}</div>
						</div>
					</div>
				</div>

				<router-link v-else to="/login" style="color: #000; text-decoration: none">
					<div style="margin-left: 10px; text-align: center" >
						<i class="el-icon-user"></i>
						<div class="f14" style="cursor: pointer">{{$t('login.title')}}</div>
						<!-- <div class="f14" style="cursor: pointer">请登录</div> -->
					</div>
				</router-link>
			</div>
		</div>
	</div>
</template>

<script>
	import eventBus from '@/utils/eventBus'
	import {
		getToken
	} from '@/utils/auth';
	import {
		logout
	} from '@/api/login'
	export default {
		name: "GlobalHeaderNav",
		data() {
			return {
				nickname: '',
				email: '',
				avatar: '../assets/img/logo.png',
				language: localStorage.getItem('cur_language') || "zh-cn",
				isLanguage: true,
				is_login: false,
				// currentLang : this.$i18n.locale
			};
		},
		mounted() {
			// 监听更新用户信息的事件
			eventBus.on('update-user', (info) => {
				console.log('on update-user', info)
				this.is_login = true
				this.nickname = info.nickname
				this.avatar = info.avatar
				this.email = info.email
			})
			var token = getToken() || null
			console.log('token', token)
			if (token != null) {
				var info = JSON.parse(localStorage.getItem('user'))
				this.is_login = true
				this.nickname = info.nickname
				this.avatar = info.avatar
				this.email = info.email
			}
			// 监听更新通知数的事件
			// eventBus.$on('update-notification', (count) => {
			// 	this.notificationCount = count
			// })
		},
		watch: {
			checkLogin() {
				console.log('checkLogin')
				this.refreshLogin()
			}
		},
		methods: {
			refreshLogin() {
				let user = localStorage.getItem('user') || null
				if (user != null) {
					user = JSON.parse(user)
					this.is_login = true
					this.nickname = user.nickname
					this.avatar = user.this.nickname
				}
			},
			goMy(){
				this.$router.push({path:'/my'})
			},
			goIndex(){
				this.$router.push({path:'/'})
			},
			quit() {
				this.$modal.confirm(this.$t('my.quit_confirm')).then(() => {
					return logout({})
				}).then(()=>{
					this.is_login = false
					localStorage.removeItem('user')
					localStorage.removeItem('App-Token')
					this.$router.push({path:'/'})
				}).catch(()=>{})
			},
			languageAuto(language) {
				console.log(language)
				// this.currentLang = language
				this.language = language
				localStorage.setItem('cur_language', language)
				// this.$i18n.locale = this.language
				window.location.reload()
				// this.language == "zh" ? (this.language = "en") : (this.language = "zh");
				// localStorage.setItem("language", `{"language":"${this.language}"}`);
				// this.isLanguage = !this.isLanguage;
				// if (this.language == "zh") {
				//   console.log("转为中文");
				//   this.$translate.changeLanguage("chinese_simplified");
				// }
				// if (this.language == "en") {
				//   console.log("转为英文");
				//   this.$translate.changeLanguage("english");
				// }
				// this.$translate.execute(); //进行翻译
			},
		},
	};
</script>

<style scoped>
	.responsive-img {
		width: 320px;
		height: 130px;
	}

	/* 媒体查询，当屏幕宽度小于等于 768px 时调整样式 */
	@media (max-width: 768px) {
		.responsive-img {
			width: 200px;
			height: 80px;
		}

		.right {
			margin-right: 10px;
		}

		.w_1200 {
			width: 100%;
		}
	}
</style>